/** @jsx jsx */

import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { jsx, css } from '@emotion/core';

type TooltipInfoProps = {
  id: number;
  description: string;
};

const TooltipInfo = ({ id, description }: TooltipInfoProps) => {
  const [openTooltip, setOpenToolTip] = useState(false);

  const toggle = () => {
    setOpenToolTip((prevOpenTooltipState) => !prevOpenTooltipState);
  };

  return (
    <React.Fragment>
      <i css={iconStyle} className="fa fa-info-circle" id={`tooltip` + id} />
      <Tooltip css={tooltipStyle} placement="right" isOpen={openTooltip} target={'tooltip' + id} toggle={toggle}>
        {description}
      </Tooltip>
    </React.Fragment>
  );
};

const tooltipStyle = css`
  font-size: 1.4rem;
`;

const iconStyle = css`
  color: #456def;
`;

export default TooltipInfo;
